var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("\n  GOAL: "+_vm._s(_vm.bendGoal)+"\n  "),_c('hr')])
}
var staticRenderFns = []

export { render, staticRenderFns }